import React from "react";

const ClockIcon = ({ size = 18, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block align-middle ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill="black" />

      <path
        d="M12 7v5l4 2"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default ClockIcon;